import ClaimsState from "@upclaim/prisma/seeds/claims_states.json"
import { ClaimState as IClaimState } from "@/interfaces/data-contracts";

export type ClaimStateType = IClaimState['type'];

const ClaimsStateByType = new Map(ClaimsState.map(cs => [cs.type as ClaimStateType, cs]));

function claimClaimStatesByType(type: ClaimStateType) {
  const claimType = ClaimsStateByType.get(type);
  if (!claimType) throw `Type error: No ClaimState named "${type}"`
  return claimType;
}

export {
  ClaimsState,
  claimClaimStatesByType,
}
